module.exports = __webpack_public_path__ + "img/max-file-approve.b07c7ee5.svg";